module.exports = __webpack_public_path__ + "img/portfolio_website.a99c6bb5.jpg";